import { FC, useEffect, useState } from 'react';
import { fetchWithAuthentication } from 'untils/getFile';
import { SmallLoader } from 'ui/SmallLoader';
import { onHttp } from 'untils/onHttp';
import { PlayVideoSvg } from 'assets/svg-icon';
import { getProtectedImageBlob } from 'untils/imageCache';

interface IProps {
  hash: string;
  endpoint?: string;
  type?: string;
}

export const Avatar: FC<IProps> = ({ hash, type, endpoint = '/storage/photo' }) => {
  const [src, setSrc] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const key = `${onHttp()}${endpoint}/${hash}`;
  const token = localStorage.getItem('token') || '';

  useEffect(() => {
    if (!Number(hash)) return;
    setLoading(true);

    let alive = true;
    let currentObjectUrl: string | undefined;

    getProtectedImageBlob(key, token, fetchWithAuthentication)
      .then((blob) => {
        if (!alive) return;
        currentObjectUrl = URL.createObjectURL(blob); // ✅ перетворюємо Blob → string URL
        setSrc(currentObjectUrl); // ✅ тепер setSrc отримує string
      })
      .catch(() => {
        if (alive) setSrc(undefined);
      })
      .finally(() => setLoading(false));

    // Якщо хочеш, можна не revoке-ити, бо URL використовується багатьма елементами.
    // Якщо потрібно — зроби LRU й ref-count.
    return () => {
      alive = false;
    };
  }, [key, token, hash]);

  if (type?.includes('video')) return <PlayVideoSvg />;

  return (
    <>
      {loading && <SmallLoader />}
      {src && (
        <img
          className="ava"
          src={src}
          alt="avatar"
          style={{ display: loading ? 'none' : 'block' }}
        />
      )}
    </>
  );
};
